// frontend/src/utils/config.js
/**
 * Base API configuration
 * 
 * This provides a fallback configuration for the API base URL.
 * The actual resolved URL is determined in api.js with this priority:
 * 1. Runtime override (window.__API_BASE__)
 * 2. Build-time env var (REACT_APP_API_BASE_URL)
 * 3. This config (REACT_APP_API_BASE with fallback)
 * 4. Relative path (/api)
 * 
 * Environment Variables:
 * - REACT_APP_API_BASE: Set in .env files (e.g., .env.production)
 * - REACT_APP_API_BASE_URL: Alternative build-time override
 */

const fromEnv = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');
const fallback = process.env.NODE_ENV === 'development' ? 'http://localhost:4000' : '';

export const API_BASE = fromEnv || fallback;